import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SidebarCSS.css';
import { AiFillAliwangwang, AiFillCaretRight, AiFillContainer, AiFillControl, AiFillDingtalkSquare, AiFillHourglass, AiFillThunderbolt } from 'react-icons/ai';
import { FaFileInvoice } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';
import { BiBuoy } from 'react-icons/bi';
import { MdDashboard } from 'react-icons/md';
import { SiInvoiceninja, SiSalesforce } from 'react-icons/si';

const SidebarNav = () => {

  const location = useLocation();


  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [expandedAdmin, setExpandedAdmin] = useState(null);
  const [expandedSubMenu, setExpandedSubMenu] = useState(null);

  const [isMasterExpanded, setIsMasterExpanded] = useState(false);
  const [isDieShopExpanded, setIsDieShopExpanded] = useState(false);
  const [isSalesExpanded, setIsSalesExpanded] = useState(false);
  const [isSalesOrderReportExpanded, setIsSalesOrderReportExpanded] = useState(false);
  const [isProductionOrderExpanded, setIsProductionOrderExpanded] = useState(false);
  const [isProductionExpanded, setIsProductionExpanded] = useState(false);
  const [isProductionReportsExpanded, setIsProductionReportsExpanded] = useState(false);
  const [isDispatchExpanded, setIsDispatchExpanded] = useState(false);
  const [isQuotationExpanded, setIsQuotationExpanded] = useState(false);
  const [isProformaInvoiceExpanded, setIsProformaInvoiceExpanded] = useState(false);

  useEffect(() => {
    const toggleSidebar = () => {
      setIsSidebarExpanded(prev => !prev);
    };

    const hamburger = document.querySelector("#toggle-btn");
    hamburger.addEventListener("click", toggleSidebar);

    return () => {
      hamburger.removeEventListener("click", toggleSidebar);
    };
  }, []);

  const toggleMaster = () => setIsMasterExpanded(prev => !prev);
  const toggleDieShop = () => setIsDieShopExpanded(prev => !prev);
  const toggleSales = () => setIsSalesExpanded(prev => !prev);
  const toggleSalesOrderReport = () => setIsSalesOrderReportExpanded(prev => !prev);
  const toggleProductionOrder = () => setIsProductionOrderExpanded(prev => !prev);
  const toggleProduction = () => setIsProductionExpanded(prev => !prev);
  const toggleProductionReports = () => setIsProductionReportsExpanded(prev => !prev);
  const toggleDispatch = () => setIsDispatchExpanded(prev => !prev);
  const toggleQuotation = () => setIsQuotationExpanded(prev => !prev);
  const toggleProformaInvoice = () => setIsProformaInvoiceExpanded(prev => !prev);

  const closeSidebar = () => setIsSidebarExpanded(false);

  const handleDashboardClick = () => {
    setIsSidebarExpanded(true);
  };


  const toggleAdmin = (adminName) => {
    setIsSidebarExpanded(true); // Ensure sidebar expands
    setExpandedAdmin(prev => (prev === adminName ? null : adminName));
    setExpandedSubMenu(null); // reset sub-submenu when main menu changes
  };

  const toggleSubMenu = (subMenuName) => {
    setIsSidebarExpanded(true); // Ensure sidebar expands
    setExpandedSubMenu(prev => (prev === subMenuName ? null : subMenuName));
  };


  const adminItems = [
    {
      name: 'Master',
      expanded: isMasterExpanded,
      toggle: toggleMaster,
      items: [
        {
          name: 'General Master',
          subItems: [
            { name: 'Designation Master', to: '/gm1' },
            { name: 'Department Master', to: '/gm2' },
            { name: 'Employee Master', to: '/gm3' },
            { name: 'Alloy Master', to: '/gm4' },
            { name: 'Press Master', to: '/gm5' },
            { name: 'Job Worker Master', to: '/gm6' },
            { name: 'HSN Code Master', to: '/gm7' },
            { name: 'Bank Detail Master', to: '/gm8' },
            { name: 'Supplier Master', to: '/gm10' },
            

          ]
        },
        {
          name: 'Purchase Master',
          subItems: [
            { name: 'Terms & Condition Master', to: '/purchasem1' },
            // { name: 'UOM Master', to: '/gm9' },
            // { name: 'Job Worker Process Master', to: '/gm11' },
            // { name: 'Job Worker Item Master', to: '/gm12' },
          ]
        },
        {
          name: 'Dies Master',
          subItems: [
            { name: 'Die Category Master', to: '/dm1' },
            { name: 'Die Sub-Category Master', to: '/dm2' },
            { name: 'Die Name Master', to: '/dm3' },
            // { name: 'Dies Master', to: '/dm4' },
            // { name: 'Die Assembly Master', to: '/dm5' },
            // { name: 'Dia Master', to: '/dm6' },
          ]
        },
        {
          name: 'Sales Master',
          subItems: [
            { name: 'Customer Master', to: '/sm1' },
            { name: 'Consignee Master', to: '/sm2' },
            { name: 'Rate Master', to: '/sm3' },
          ]
        },
        {
          name: 'Production Master',
          subItems: [
            // { name: 'Machine Master', to: '/pm1' },
            { name: 'Rack Master', to: '/pm2' },
            // { name: 'Shift Master', to: '/pm3' },
            { name: 'Temper Master', to: '/pm4' },
          ]
        },
      ]
    },
    // {
    //   name: 'Die Shop',
    //   expanded: isDieShopExpanded,
    //   toggle: toggleDieShop,
    //   items: [
    //     { name: 'NI Trading Entry', to: '/dieshop1' },
    //     { name: 'Die Status Change', to: '/dieshop2' },
    //     { name: 'Die Wise Report', to: '/dieshop3' },
    //     { name: 'Die Name Wise Report', to: '/dieshop4' },
    //     { name: 'NI Trading Due Report', to: '/dieshop5' },
    //     { name: 'Customer Wise Die Report', to: '/dieshop6' },
    //   ]
    // },
    {
      name: 'Sales',
      expanded: isSalesExpanded,
      toggle: toggleSales,
      items: [
        { name: 'Pre Order Entry', to: '/sales2' },
        { name: 'Order Entry', to: '/sales1' },
        // { name: 'Order Status', to: '/sales3' },
        { name: 'Job Sheet Approval', to: '/sales4' },
        { name: 'Rate Approval', to: '/sales5' },
       // { name: 'Job Sheet Closure Status', to: '/sales6' },
        { name: 'Order Allotment', to: '/sales7' },
        { name: 'Stock Checking', to: '/sales8' },
      ]
    },
    {
      name: 'Sales Order Report',
      expanded: isSalesOrderReportExpanded,
      toggle: toggleSalesOrderReport,
      items: [
        { name: 'Sales Item Wise Report', to: '/salesorder1' },
        { name: 'Sales Detail Register', to: '/salesorder2' },
        { name: 'Packing List Report', to: '/salesorder3' },
        { name: 'Item Stock Report', to: '/salesorder4' },
        { name: 'Rack Wise Details', to: '/salesorder5' },
      ]
    },
    {
      name: 'Production Order',
      expanded: isProductionOrderExpanded,
      toggle: toggleProductionOrder,
      items: [
        { name: 'Pending Order Summary', to: '/porder1' },
        { name: 'Order Paper', to: '/porder2' },
      ]
    },
    {
      name: 'Production',
      expanded: isProductionExpanded,
      toggle: toggleProduction,
      items: [
        // { name: 'Press Input', to: '/production1' },
        { name: 'Press Output', to: '/production2' },
        { name: 'Close Rack', to: '/production3' },
        { name: 'Ageing', to: '/production4' },
        { name: 'Rack Remark', to: '/production5' },
        { name: 'Packing Details Entry', to: '/production6' },
        // { name: 'Release Rack', to: '/production7' },
      ]
    },
    {
      name: 'Production Reports',
      expanded: isProductionReportsExpanded,
      toggle: toggleProductionReports,
      items: [
        { name: 'Ageing Report', to: '/preport1' },
        { name: 'Packing Rejection Report', to: '/preport2' },
        { name: 'Manufacture Report', to: '/preport3' }
      ]
    },
    {
      name: 'Dispatch',
      expanded: isDispatchExpanded,
      toggle: toggleDispatch,
      items: [
                { name: 'Dispatch', to: '/dispatch1' },
         { name: 'Dispatch Delivery Summary', to: '/dispatch5' },
        { name: 'Job Work', to: '/dispatch2' },
        { name: 'Job Work Dispatch', to: '/dispatch3' },
        { name: 'Job Work Delivery Summary', to: '/dispatch6' },
         { name: 'Miscellaneous Update', to: '/dispatch4' },
      ]
    },
    {
      name: 'Quotation',
      expanded: isQuotationExpanded,
      toggle: toggleQuotation,
      items: [
        { name: 'Quotation', to: '/quotation1' },
        { name: 'Proforma Invoice', to: '/quotation2' },
      ]
    },
    {
      name: 'Proforma Invoice',
      expanded: isProformaInvoiceExpanded,
      toggle: toggleProformaInvoice,
      items: [
        { name: 'Proforma Invoice', to: '/pinvoice-1' }
      ]
    },
  ];

  //=======================================================

   // Function to check if a link is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Function to check if any of the submenu or sub-submenu is active, to keep parent expanded/highlighted
  const isSubMenuActive = (subItems) => {
    if (!subItems) return false;
    return subItems.some(item => isActive(item.to));
  };

  // For main admin item, check if any nested item is active to highlight it
  const isAdminActive = (admin) => {
    if (!admin.items) return false;
    return admin.items.some(item => {
      if (item.subItems) {
        return isSubMenuActive(item.subItems);
      }
      return isActive(item.to);
    });
  };


  // Automatically expand the admin and submenu if current path is inside them
  useEffect(() => {
    adminItems.forEach(admin => {
      if (isAdminActive(admin)) {
        setExpandedAdmin(admin.name);
        // find which submenu is active
        admin.items.forEach(item => {
          if (item.subItems && isSubMenuActive(item.subItems)) {
            setExpandedSubMenu(item.name);
          }
        });
      }
    });
  }, [location.pathname]);

  //=======================================================

  return (

    <aside id='sidebar' className={isSidebarExpanded ? 'expand' : ''}>
      <div className="py-2">
        <span id='toggle-btn' type='button'>
          <i className="fa-solid fa-bars"></i> &nbsp;&nbsp;
          {isSidebarExpanded && <span className="toggle-name text-white">Sangli Aluminium</span>}
        </span>
      </div>

      {/* <div className='p-0 sidebarItems no-select'>
        <ul style={{ padding: "0px 10px 0px 10px" }}>

          <li>
            <Link className='listMenu' to="/dashboard" onClick={handleDashboardClick}>
              <MdDashboard style={{ color: "#0466c8" }} />
              {isSidebarExpanded && <span className='listMenuName' >Dashboard</span>}
            </Link>
          </li>

          {adminItems.map((admin, index) => (
            <li key={index}>
              <span className='listMenu'  onClick={() => toggleAdmin(admin.name)}>
                {admin.name.includes('Master') && <AiFillThunderbolt style={{ color: "#0466c8" }} />}
                {admin.name.includes('Die Shop') && <AiFillHourglass style={{ color: "#0466c8" }} />}
                {admin.name.includes('Sales') && <BiBuoy style={{ color: "#0466c8" }} />}
                {admin.name.includes('SalesOrder Report') && <SiSalesforce style={{ color: "#0466c8" }} />}
                {admin.name.includes('ProductionOrder') && <AiFillDingtalkSquare style={{ color: "#0466c8" }} />}
                {admin.name.includes('Production') && <AiFillContainer style={{ color: "#0466c8" }} />}
                {admin.name.includes('ProductionReports') && <AiFillControl style={{ color: "#0466c8" }} />}
                {admin.name.includes('Dispatch') && <AiFillAliwangwang style={{ color: "#0466c8" }} />}
                {admin.name.includes('Quotation') && <SiInvoiceninja style={{ color: "#0466c8" }} />}
                {admin.name.includes('Proforma Invoice') && <FaFileInvoice style={{ color: "#0466c8" }} />}
                {isSidebarExpanded && (
                  <span className='listMenuName'>
                    {admin.name}
                    {admin.items && admin.items.length > 0 && (
                      <IoIosArrowDown className={`arrow-down ${expandedAdmin === admin.name ? 'rotated' : ''}`} />
                    )}
                  </span>
                )}
              </span>

              {expandedAdmin === admin.name && isSidebarExpanded && (
                <ul className='nestedMenu' style={{ padding: "0px 10px 0px 20px" }}>
                  {admin.items.map((item, subIndex) => (
                    <li key={subIndex}>
                      {item.subItems ? (
                        <>
                          <div
                            className='linkItems'
                            onClick={() => toggleSubMenu(item.name)}
                          >
                            <AiFillCaretRight />
                            <span>
                              {item.name}
                              {item.subItems && (
                                <IoIosArrowDown className={`arrow-down ${expandedSubMenu === item.name ? 'rotated' : ''}`} />
                              )}
                            </span>
                          </div>
                          {expandedSubMenu === item.name && (
                            <ul className='nestedMenu' style={{ paddingLeft: "20px" }}>
                              {item.subItems.map((subItem, subSubIndex) => (
                                <li key={subSubIndex}>
                                  <Link className='linkItems' to={subItem.to} onClick={closeSidebar}>
                                    <AiFillCaretRight /> {subItem.name}
                                  </Link>
                                </li>
                              ))} 
                            </ul>
                          )}
                        </>
                      ) : (
                        <Link className='linkItems' to={item.to} onClick={closeSidebar}>
                          <AiFillCaretRight /> {item.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div> */}

       <div className='p-0 sidebarItems no-select'>
      <ul style={{ padding: "0px 10px 0px 10px" }}>
        <li>
          <Link
            className={`listMenu ${isActive('/dashboard') ? 'active' : ''}`}
            to="/dashboard"
            onClick={handleDashboardClick}
          >
            <MdDashboard style={{ color: "#0466c8" }} />
            {isSidebarExpanded && <span className='listMenuName'>Dashboard</span>}
          </Link>
        </li>

        {adminItems.map((admin, index) => (
          <li key={index}>
            <span
              className={`listMenu ${isAdminActive(admin) ? 'active' : ''}`}
              onClick={() => toggleAdmin(admin.name)}
              style={{ cursor: 'pointer' }}
            >
              {/* Your icon logic */}
              {admin.name.includes('Master') && <AiFillThunderbolt style={{ color: "#0466c8" }} />}
              {admin.name.includes('Die Shop') && <AiFillHourglass style={{ color: "#0466c8" }} />}
              {admin.name.includes('Sales') && <BiBuoy style={{ color: "#0466c8" }} />}
              {admin.name.includes('SalesOrder Report') && <SiSalesforce style={{ color: "#0466c8" }} />}
              {admin.name.includes('ProductionOrder') && <AiFillDingtalkSquare style={{ color: "#0466c8" }} />}
              {admin.name.includes('Production') && !admin.name.includes('Production Reports') && <AiFillContainer style={{ color: "#0466c8" }} />}
              {admin.name.includes('Production Reports') && <AiFillControl style={{ color: "#0466c8" }} />}
              {admin.name.includes('Dispatch') && <AiFillAliwangwang style={{ color: "#0466c8" }} />}
              {admin.name.includes('Quotation') && <SiInvoiceninja style={{ color: "#0466c8" }} />}
              {admin.name.includes('Proforma Invoice') && <FaFileInvoice style={{ color: "#0466c8" }} />}
              {isSidebarExpanded && (
                <span className='listMenuName'>
                  {admin.name}
                  {admin.items && admin.items.length > 0 && (
                    <IoIosArrowDown className={`arrow-down ${expandedAdmin === admin.name ? 'rotated' : ''}`} />
                  )}
                </span>
              )}
            </span>

            {expandedAdmin === admin.name && isSidebarExpanded && (
              <ul className='nestedMenu' style={{ padding: "0px 10px 0px 20px" }}>
                {admin.items.map((item, subIndex) => (
                  <li key={subIndex}>
                    {item.subItems ? (
                      <>
                        <div
                          className={`linkItems ${expandedSubMenu === item.name || isSubMenuActive(item.subItems) ? 'active' : ''}`}
                          onClick={() => toggleSubMenu(item.name)}
                          style={{ cursor: 'pointer' }}
                        >
                          <AiFillCaretRight />
                          <span>
                            {item.name}
                            {item.subItems && (
                              <IoIosArrowDown className={`arrow-down ${expandedSubMenu === item.name ? 'rotated' : ''}`} />
                            )}
                          </span>
                        </div>
                        {(expandedSubMenu === item.name || isSubMenuActive(item.subItems)) && (
                          <ul className='nestedMenu' style={{ paddingLeft: "20px" }}>
                            {item.subItems.map((subItem, subSubIndex) => (
                              <li key={subSubIndex}>
                                <Link
                                  className={`linkItems ${isActive(subItem.to) ? 'active' : ''}`}
                                  to={subItem.to}
                                  onClick={closeSidebar}
                                >
                                  <AiFillCaretRight /> {subItem.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </>
                    ) : (
                      <Link
                        className={`linkItems ${isActive(item.to) ? 'active' : ''}`}
                        to={item.to}
                        onClick={closeSidebar}
                      >
                        <AiFillCaretRight /> {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>

    </aside>

  );
};

export default SidebarNav;